import type {
  Manufacturer,
  ManufacturerEntity,
} from '~/domain/Insurance/manufacturerEntity';
import type { ManufacturerResponseDTO } from '~/dto/Insurance/manufacturerDTO';

export const manufacturerResponseMapper = ({
  success,
  resultData,
}: ManufacturerResponseDTO): ManufacturerEntity => {
  if (success && resultData.length > 0) {
    const manufacturers: Manufacturer[] = resultData.map((item) => ({
      value: item.codigo,
      label: item.descricao,
    }));

    return <ManufacturerEntity>{
      success,
      manufacturers,
    };
  }

  return { success: false, manufacturers: [] };
};
